// extracted by mini-css-extract-plugin
module.exports = {"productChips":"ProductChips_productChips__3LzkC","bestseller":"ProductChips_bestseller__5Btau"};